(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Gold": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          killSelf: true,
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 0, anyPower: 1, domains: null },
              bonusTag: "gold",
            },
          ],
          label: "Add",
        },
      ],
    },

    "Minefield": {
      triggers: [
        {
          on: "conquer",
          selfBf: true,
          you: true,
          label: "when you conquer here",
          targets: [],
          program: [{ op: "burn", n: 2 }],
        },
      ],
    },

    "Power Nexus": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [],
          program: [
            {
              op: "may",
              prompt: "Pay [rune_rainbow][rune_rainbow][rune_rainbow][rune_rainbow]?",
              then: [
                {
                  op: "payCost",
                  cost: { energy: 0, pips: 0, anyPower: 4, domains: null },
                  skipOnFail: 1,
                },
                { op: "points", n: 1 },
              ],
            },
          ],
        },
      ],
    },

    "The Papertree": {
      triggers: [
        {
          on: "hold",
          selfBf: true,
          you: true,
          label: "when you hold here",
          targets: [],
          program: [
            { op: "channel", n: 1, exhausted: true },
            { op: "channel", who: "opponent", n: 1, exhausted: true },
          ],
        },
      ],
    },

    "Treasure Hoard": {
      triggers: [
        {
          on: "conquer",
          selfBf: true,
          you: true,
          label: "when you conquer here",
          targets: [],
          program: [
            {
              op: "may",
              prompt: "Pay [energy_1]?",
              then: [
                {
                  op: "payCost",
                  cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
                  skipOnFail: 1,
                },
                { op: "token", name: "Gold", n: 1, loc: "base", exhausted: true },
              ],
            },
          ],
        },
      ],
    },

    "Emperor's Dais": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "tribute of sand",
        program: [{
          op: "may", prompt: "Pay 1 Energy and return a unit you control here to its owner's hand?",
          then: [
            {
              op: "choose", bind: "u", spec: { type: "unit", friendly: true, here: true },
              prompt: "Return which unit here to its owner's hand?",
            },
            {
              op: "if", cond: { k: "targetsChosen", bind: "u" }, then: [
                { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, varKey: "dais", skipOnFail: 2 },
                { op: "toHand", to: "$u" },
                { op: "token", name: "Sand Soldier", loc: "here" },
              ],
            },
          ],
        }],
      }],
    },

    "Forgotten Monument": {
      restrictScore: [{
        who: "all", here: true,
        reason: "Forgotten Monument: no scoring here until your third turn",
        cond: {
          k: "or", conds: [
            { k: "turnMax", n: 4 },
            { k: "and", conds: [{ k: "turnMax", n: 5 }, { k: "not", cond: { k: "myTurn" } }] },
          ],
        },
      }],
    },

    "Ornn's Forge": {
      auraCostMod: [{
        who: "friendly", requiresControl: true,
        what: { type: "gear", nonToken: true },
        energyLess: 1,
        cond: { k: "turnFact", key: "gearPlayed", n: 0, cmp: "exactly" },
      }],
    },

    "Ravenbloom Conservatory": {
      triggers: [{
        on: "combatStart", selfBf: true, condSpec: { k: "showdownHereDefending" },
        label: "conservatory bloom",
        program: [{
          op: "lookTopTake", n: 1, public: true, take: "hand", filter: { type: "spell" },
          prompt: "Put the revealed spell into your hand",
        }],
      }],
    },

    "Rockfall Path": {
      restrictPlayHere: [{ what: { type: "unit" } }],
    },

    "Seat of Power": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "seat of power",
        program: [{ op: "draw", n: { count: { zone: "battlefield", friendly: true, other: true } } }],
      }],
    },

    "Sunken Temple": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "temple offering",
        condSpec: { k: "count", spec: { type: "unit", friendly: true, here: true, minMight: 5 }, n: 1 },
        program: [{
          op: "may", prompt: "Pay 1 Energy to draw 1?", then: [
            { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, varKey: "sunken", skipOnFail: 1 },
            { op: "draw", n: 1 },
          ],
        }],
      }],
    },

    "Veiled Temple": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "veiled rearmament",
        program: [{
          op: "may", prompt: "Ready a friendly gear?", then: [
            {
              op: "choose", bind: "g", spec: { type: "gear", friendly: true, attached: true },
              prompt: "Ready which friendly gear?",
            },
            { op: "ready", to: "$g" },
            {
              op: "if", cond: { k: "targetTag", bind: "g", tag: "Equipment" }, then: [
                { op: "may", prompt: "Detach that Equipment?", then: [{ op: "detach", to: "$g" }] },
              ],
            },
          ],
        }],
      }],
    },

    "Forge of the Fluft": {
      auraAbilities: [{
        who: "friendly", requiresControl: true,
        what: { legend: true },
        ability: {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          label: "Attach an Equipment you control to a unit you control",
          targets: [
            {
              bind: "g", spec: { type: "gear", equipment: true, friendly: true, attached: true },
              prompt: "Attach which Equipment?",
            },
            { bind: "u", spec: { type: "unit", friendly: true }, prompt: "Attach it to which friendly unit?" },
          ],
          program: [{ op: "attach", to: "$g", host: "$u" }],
        },
      }],
    },

    "Hall of Legends": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, optional: true,
        label: "conquer here: pay 1 to ready your legend",
        program: [
          { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, skipOnFail: 1 },
          { op: "ready", spec: { zone: "legend", friendly: true } },
        ],
      }],
    },

    "Marai Spire": {
      auraCostMod: [{ repeat: true, who: "friendly", requiresControl: true, energyLess: 1 }],
    },
  });
})();
